<template>
  <div class="comments-section">
    <title-component
      :size="4"
      :lineSeparator="'under'">
      Comments
    </title-component>
    <comment-finding-component
      :comment="finding">
    </comment-finding-component>
    <comment-finding-component
      v-for="comment in finding.comments"
      :key="comment.id"
      :comment="comment">
    </comment-finding-component>
  </div>
</template>
<script>
  import { ReviewResultFinding } from '@/classes/case/ReviewResult'
  import TitleComponent from '@/components/layout/TitleComponent'
  import CommentFindingComponent from '@/components/layout/utility/CommentFindingComponent'

  export default {
    name: 'comment-finding-list-component',
    components: {
      TitleComponent,
      CommentFindingComponent
    },
    props: {
      finding: {
        type: ReviewResultFinding,
        required: true
      }
    }
  }
</script>
